<ngx-spinner type="ball-atom"></ngx-spinner>
<div class="component-container">
  <div class="component-header">
    <h2>Accounting Standards</h2>
    <div class="button-group">
      <button mat-raised-button color="primary" (click)="onAccountingStandardCorrected()" *ngIf="rightItem && matchedItems && matchedItems.length > 0">
        <mat-icon>assignment_turned_in</mat-icon>
        Correct
      </button>
      <button mat-raised-button color="primary" (click)="onCreateAccountingStandard()">
        <mat-icon>add</mat-icon>
        Add Accounting Standard
      </button>
    </div>
  </div>
  <app-lookup-table
      [items]="accountingStandards()"
      [enableMatching]="true"
      (itemClick)="onItemSelected($event)"
      (editClick)="onEditAccountingStandard($event)"
      (deleteClick)="onDeleteAccountingStandard($event)"
      (itemSave)="onItemSave($event)"
      (itemAdd)="onItemAdd($event)"
      (readyToMatch)="onReadyToMatch($event)">
    </app-lookup-table>
</div>
